import { Controller, useForm } from "react-hook-form";
import { ModalGeneric } from "../../../utils/ModalGeneric";
import DatePicker, { registerLocale } from "react-datepicker";
import { ptBR } from "date-fns/locale";
import { addHours, format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import CustomDateInput from "@/components/InputCustom/DateInput";

registerLocale("pt-BR", ptBR);
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useNavigate } from "react-router-dom";
import serviceMeetings from "@/services/serviceMeetings";
import { toast } from "react-toastify";
import notify from "@/services/notify.tsx";
import { useCallback, useEffect, useRef, useState } from "react";
import type { ClipboardEvent } from "react";
import { useLayout } from "../../../../contexts/UseLayout";
import debounce from "lodash.debounce";
import CadastroAgenciaService from "@/services/cadastroAgencia";
import ConfigDesks from "@/services/configDesks";
import serviceProspect from "@/services/serviceProspect";
import ServiceRepresentantes from "@/services/serviceRepresentante";
import GetAllClientes from "@/services/getClientes";
import moment from "moment";
import ImageGeneric from "@/assets/images/lg.png";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import ServiceRepresentado from "@/services/serviceRepresentado";
import { useTranslation } from "react-i18next";
import {
  CalendarDays,
  CheckCircle2,
  ChevronDown,
  CircleAlert,
  Clock3,
  DoorOpen,
  Repeat2,
  Settings2,
  UsersRound,
} from "lucide-react";
import {
  buildMeetingRoomOption,
  DEFAULT_ROOM_COLORS,
  DEFAULT_MEETING_DURATION_MINUTES,
} from "@/constants/meetingRooms";

function resolveImageSrc(raw: any): string | null {
  if (!raw) return null;
  if (typeof raw === "string") return raw;
  return raw.path ?? raw.url ?? null;
}

function createRecurrenceRequestId() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();

  const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const value = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"));
  return `${value.slice(0, 4).join("")}-${value.slice(4, 6).join("")}-${value.slice(6, 8).join("")}-${value.slice(8, 10).join("")}-${value.slice(10).join("")}`;
}

type SelectSourceItem = {
  id?: string | number;
  cliente_id?: string | number;
  type_id?: number;
  name?: string;
  name_fantasy?: string;
  nameFantasia?: string;
  nameCompleto?: string;
  nome?: string;
  nome_completo?: string;
  last_name?: string;
  email?: string;
  filePath?: string;
  base_clientes?: string;
  representados?: SelectSourceItem[];
};

const WEEKDAYS = [
  { value: 0, short: "D", label: "domingo" },
  { value: 1, short: "S", label: "segunda-feira" },
  { value: 2, short: "T", label: "terça-feira" },
  { value: 3, short: "Q", label: "quarta-feira" },
  { value: 4, short: "Q", label: "quinta-feira" },
  { value: 5, short: "S", label: "sexta-feira" },
  { value: 6, short: "S", label: "sábado" },
] as const;

function getFirstRecurrenceDate(start: string, weekdays: number[]) {
  if (!start || weekdays.length === 0) return null;
  const candidate = moment(start).clone();
  for (let offset = 0; offset < 7; offset += 1) {
    if (weekdays.includes(candidate.day())) return candidate;
    candidate.add(1, "day");
  }
  return null;
}

function formatWeekdayList(weekdays: number[]) {
  const labels: any = WEEKDAYS.filter((day) =>
    weekdays.includes(day.value),
  ).map((day) => day.label);
  if (labels.length <= 1) return labels[0] ?? "";
  return `${labels.slice(0, -1).join(", ")} e ${labels.at(-1)}`;
}

const TIMEZONE_SUFFIX_REGEX = /(Z|[+-]\d{2}:?\d{2})$/i;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MAX_EMAIL_LENGTH = 254;

type ExternalAttendeeOption = { value: string; label: string };

function normalizeEmail(value: string) {
  return value.trim().toLowerCase();
}

function isValidEmail(value: string) {
  return value.length <= MAX_EMAIL_LENGTH && EMAIL_REGEX.test(value);
}

function toExternalAttendeeOptions(value: unknown): ExternalAttendeeOption[] {
  if (!Array.isArray(value)) return [];
  const emails = value
    .map((item) => {
      if (typeof item === "string") return normalizeEmail(item);
      if (!item || typeof item !== "object") return "";
      const attendee = item as { email?: unknown; value?: unknown };
      const raw =
        typeof attendee.email === "string"
          ? attendee.email
          : typeof attendee.value === "string"
            ? attendee.value
            : "";
      return normalizeEmail(raw);
    })
    .filter(isValidEmail);
  return [...new Set(emails)].map((email) => ({ value: email, label: email }));
}

function serializeMeetingDateForApi(value: any) {
  if (!value) return value;

  const rawValue =
    value instanceof Date
      ? format(value, "yyyy-MM-dd'T'HH:mm:ss")
      : String(value).trim();
  if (!rawValue) return value;

  const date = moment(rawValue.replace(TIMEZONE_SUFFIX_REGEX, ""));
  return date.isValid()
    ? `${date.format("YYYY-MM-DDTHH:mm:ss")}Z`
    : value;
}

export function FormReunions({
  reuniao,
  setReuniao,
  reload,
  close,
  initialProspect,
  initialCandidatura,
  initialCarteiraPessoa,
  onSaved,
}: any) {
  const context = useLayout();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const typeUser: any = context?.userLogged?.data?.type_user_id;
  const user: any = context?.userLogged?.data;

  const [submiting, isSubmiting] = useState(false);
  const [externalAttendeeInput, setExternalAttendeeInput] = useState("");
  const [isEdit, setIsEdit] = useState(false);

  const [clients, setClients] = useState<any>([]);

  const [typesReunion, setTypesReunion] = useState<any>([]);

  const [agencys, setAgencys] = useState<any>([]);
  const [loadingAgency, setLoadingAgency] = useState(false);

  const [users, setUsers] = useState<any>([]);
  const [loadingUsers, setLoadingUsers] = useState(false);

  const [prospects, setProspects] = useState<any>([]);
  const [loadingProspects, setLoadingProspects] = useState(false);

  const [veiculos, setVeiculos] = useState<any>([]);

  const [representantes, setRepresentantes] = useState<any>([]);
  const [loadingRepresentante, setLoadingRepresentante] = useState(false);

  const [clientesNaoMidia, setClientesNaoMidia] = useState<any>([]);
  const [loadingClientesNaoMidia, setLoadingClientesNaoMidia] = useState(false);
  const [checkingRoom, setCheckingRoom] = useState(false);
  const [creatingRoom, setCreatingRoom] = useState(false);
  const [roomSearch, setRoomSearch] = useState("");
  const [roomAvailability, setRoomAvailability] = useState<{
    available: boolean;
    message?: string;
    checkedKey?: string;
  } | null>(null);
  const [showAdditionalFields, setShowAdditionalFields] = useState(true);
  const [editingRecurrenceId, setEditingRecurrenceId] = useState<
    string | number | null
  >(null);
  const editRequestSequence = useRef(0);
  const [recurrenceRequestId] = useState(createRecurrenceRequestId);
  const isRecruitmentMeeting = !!initialCandidatura && !reuniao;

  const projetos = context?.getConfig?.typesDesks;

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    control,
    trigger,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      meeting_type: { value: "reunion", label: "Reunião" },
      is_recurring: false,
      recurrence_weekdays: [],
      recurrence_end_type: "never",
      recurrence_count: 6,
      recurrence_end_date: "",
      recurrence_scope: "",
      external_attendees: [],
    },
  });

  const currentStatus = watch("status")?.value ?? watch("status");

  const meetingTypeValue = watch("meeting_type")?.value;
  const isReunion = meetingTypeValue === "reunion";
  const requiresRoom = Boolean(meetingTypeValue);
  const selectedRoom = watch("meeting_room")?.value;
  const selectedStartDate = watch("date");
  const selectedEndDate = watch("end_date");
  const selectedStatus = String(currentStatus ?? "");
  const isRoomValidationStatus = ["1", "3"].includes(selectedStatus);
  const roomOrScheduleChanged =
    !isEdit ||
    String(reuniao?.meeting_room_id ?? "") !== String(selectedRoom ?? "") ||
    serializeMeetingDateForApi(reuniao?.date) !==
      serializeMeetingDateForApi(selectedStartDate) ||
    serializeMeetingDateForApi(reuniao?.end_date) !==
      serializeMeetingDateForApi(selectedEndDate) ||
    String(reuniao?.status ?? "") !== selectedStatus;
  const shouldCheckRoomAvailability =
    requiresRoom && isRoomValidationStatus && roomOrScheduleChanged;
  const isRecurring = watch("is_recurring");
  const recurrenceWeekdays: number[] = watch("recurrence_weekdays") ?? [];
  const recurrenceEndType = watch("recurrence_end_type") ?? "never";
  const recurrenceCount = Number(watch("recurrence_count") || 0);
  const recurrenceEndDate = watch("recurrence_end_date");
  const recurrenceScope = watch("recurrence_scope");
  const isRecurringEdit = isEdit && Boolean(editingRecurrenceId);
  const isGoogleMeeting = isEdit && reuniao?.calendar_origin === "google";
  const firstRecurrenceDate = getFirstRecurrenceDate(
    selectedStartDate,
    recurrenceWeekdays,
  );
  const availabilityKey =
    selectedRoom && selectedStartDate && selectedEndDate
      ? `${selectedRoom}|${selectedStartDate}|${selectedEndDate}`
      : null;

  const { data: meetingRoomsResponse, isLoading: loadingRooms } = useQuery({
    queryKey: ["meeting-rooms", "active"],
    queryFn: async () => serviceMeetings.getMeetingRooms({ active: true }),
    staleTime: 1000 * 60 * 5,
  });

  const meetingRooms = meetingRoomsResponse?.data?.data ?? [];
  const roomOptions = meetingRooms.map((room: any) => ({
    value: room.id,
    label: room.name,
    data: room,
  }));
  const roomSearchTerm = roomSearch.trim().toLowerCase();
  const hasRoomSearchResult =
    !roomSearchTerm ||
    roomOptions.some((room: any) =>
      room.label.toLowerCase().includes(roomSearchTerm),
    );

  const onSubmit = async (data: any) => {
    if (isRecurringEdit && !isGoogleMeeting && !data.recurrence_scope) {
      toast.error("Escolha quais reuniões deseja atualizar.");
      return;
    }
    if (data?.meeting_type?.value === "reunion" && !isGoogleMeeting) {
      let hasMissingBusinessField = false;
      const requireBusinessField = (name: string, message: string) => {
        const value = data?.[name]?.value;
        if (value === null || value === undefined || value === "") {
          setError(name, { type: "required", message });
          hasMissingBusinessField = true;
        }
      };

      if (![3, 8].includes(typeUser)) {
        requireBusinessField("type", "Selecione o tipo de reunião.");
      }
      if (
        typeUser !== 2 &&
        !isRecruitmentMeeting &&
        ![3, 8].includes(typeUser)
      ) {
        requireBusinessField("id_project", "Selecione o projeto.");
      }
      requireBusinessField("id_responsavel", "Selecione o responsável.");

      if (!isRecruitmentMeeting && data?.type?.value == 2) {
        if (![3].includes(typeUser) && typeUser !== 8) {
          requireBusinessField(
            "id_representante",
            "Selecione o representante.",
          );
        }
        if (typeUser !== 8) {
          requireBusinessField("id_representado", "Selecione o veículo.");
        }
      }

      if (hasMissingBusinessField) {
        setShowAdditionalFields(true);
        toast.error("Preencha os campos obrigatórios da reunião.");
        return;
      }
    }

    if (!isGoogleMeeting && moment(data.end_date).isSameOrBefore(moment(data.date))) {
      toast.error("O horário final deve ser depois do horário inicial.");
      return;
    }
    if (
      shouldCheckRoomAvailability &&
      (roomAvailability?.available !== true ||
        roomAvailability?.checkedKey !== availabilityKey)
    ) {
      toast.error(
        roomAvailability?.message ||
          "Aguarde a confirmação de disponibilidade da sala.",
      );
      return;
    }

    isSubmiting(true);
    const toastId = notify.loading("Salvando reunião...");

    try {
      data.external_attendees = toExternalAttendeeOptions(
        data.external_attendees,
      ).map((attendee) => attendee.value);
      if (data.list_integrantes === undefined) {
        data.list_integrantes = [];
      } else {
        data.list_integrantes = JSON.stringify(
          data?.list_integrantes.map((integrante: any) => integrante.value),
        );
      }

      data.date = serializeMeetingDateForApi(data.date);
      data.end_date = serializeMeetingDateForApi(data.end_date);
      data.id_agencia =
        typeUser === 2 ? user?.agency_id : data?.id_agencia?.value;
      data.id_client = data?.id_client?.value ?? null;
      data.id_representante = data?.id_representante?.value;
      data.id_representado = data?.id_representado?.value;
      data.id_responsavel = data?.id_responsavel?.value;
      data.id_protagonista = data?.id_protagonista?.value;
      data.id_prospecting = data?.id_prospecting?.value;
      data.type = data?.type?.value;
      data.id_project = data?.id_project?.value;
      data.is_reunion = data?.meeting_type?.value === "reunion";
      data.meeting_room_id = data?.meeting_room?.value;
      data.meeting_room = data?.meeting_room?.label;
      data.is_recurring = data.is_recurring === true;
      data.recurrence_weekdays = data.is_recurring
        ? data.recurrence_weekdays
        : null;
      data.recurrence_end_type = data.is_recurring
        ? data.recurrence_end_type
        : null;
      data.recurrence_end_date =
        data.is_recurring && data.recurrence_end_type === "date"
          ? data.recurrence_end_date
          : null;
      data.recurrence_count =
        data.is_recurring && data.recurrence_end_type === "count"
          ? Number(data.recurrence_count)
          : null;
      data.recurrence_id = isRecurringEdit
        ? reuniao.recurrence_id
        : data.is_recurring
          ? recurrenceRequestId
          : null;
      data.recurrence_scope = isRecurringEdit ? data.recurrence_scope : null;

      let res;
      if (isEdit) {
        if (isGoogleMeeting) {
          const crmPayload = {
            id_agencia: data.id_agencia,
            id_client: data.id_client,
            id_representante: data.id_representante,
            id_representado: data.id_representado,
            id_responsavel: data.id_responsavel,
            id_protagonista: data.id_protagonista,
            id_prospecting: data.id_prospecting,
            type: data.type,
            id_project: data.id_project,
            links: data.links,
          };
          res = await serviceMeetings.editMeeting(reuniao.id, crmPayload);
        } else {
          data.status = data?.status?.value;
          res = await serviceMeetings.editMeeting(reuniao.id, data);
        }
      } else {
        data.status = 1;
        res = await serviceMeetings.newMeeting(data);
      }
      if (res.status === 200 || res.status === 201) {
        const pendingCalendarCount =
          res.data?.calendar_sync_pending?.length ?? 0;
        notify.update(
          toastId,
          pendingCalendarCount > 0 ? "warning" : "success",
          pendingCalendarCount > 0
            ? `${res.data.msg || "Compromisso salvo"}. ${pendingCalendarCount} ocorrência(s) aguardam sincronização com o Google Calendar.`
            : res.data.msg || "Reunião salva!",
        );
        onSaved?.(res.data);
        queryClient.invalidateQueries({ queryKey: ["meeting-room"] });
        queryClient.invalidateQueries({ queryKey: ["meeting-rooms"] });
        closeModal();
        reload?.();
      } else {
        const conflictDate = res?.data?.conflict_date
          ? ` Conflito em ${moment(res.data.conflict_date).format(
              "DD/MM/YYYY [às] HH:mm",
            )}.`
          : "";
        notify.update(
          toastId,
          "error",
          `${res?.data?.msg || "Erro ao salvar reunião"}${conflictDate}`,
        );
      }
    } catch (error: any) {
      console.log(error);
      notify.update(
        toastId,
        "error",
        error?.response?.data?.msg ||
          error?.response?.data?.error ||
          "Erro ao salvar reunião",
      );
    } finally {
      isSubmiting(false);
    }
  };

  const loadAgencys = useCallback(
    debounce(async (inputValue) => {
      if (inputValue) {
        setLoadingAgency(true);
        const res = await CadastroAgenciaService.listarAgencys(
          1,
          10,
          inputValue,
        );
        if (res.status === 200) {
          setAgencys(res.data.data);
        }
        setLoadingAgency(false);
      } else {
        setAgencys([]);
      }
    }, 300),
    [],
  );

  const handleInputChange = (inputValue: any) => {
    loadAgencys(inputValue);
    return inputValue;
  };

  const loadUsers = useCallback(
    debounce(async (inputValue) => {
      if (inputValue) {
        setLoadingUsers(true);
        const res = await ConfigDesks.getContatosBusca(1, 10, inputValue);
        if (res.status === 200) {
          setUsers(res.data.data);
        }
        setLoadingUsers(false);
      } else {
        setUsers([]);
      }
    }, 300),
    [],
  );

  const handleInputChangeUsers = (inputValue: any) => {
    loadUsers(inputValue);
    return inputValue;
  };

  const loadProspects = useCallback(
    debounce(async (inputValue) => {
      if (inputValue) {
        setLoadingProspects(true);
        const res = await serviceProspect.getProspect(1, 10, inputValue);
        if (res.status === 200) {
          setProspects(res.data.data);
        }
        setLoadingProspects(false);
      } else {
        setProspects([]);
      }
    }, 300),
    [],
  );

  const handleInputChangeProspects = (inputValue: any) => {
    loadProspects(inputValue);
    return inputValue;
  };

  const loadProtagonista = useCallback(
    debounce(async (inputValue) => {
      if (inputValue) {
        setLoadingUsers(true);
        const resAgency = await ConfigDesks.getContatosBusca(
          1,
          10,
          inputValue,
          "",
          watch("id_agencia")?.value,
          "",
          "",
          "",
          "",
          "",
          "",
        );
        const resClient = await ConfigDesks.getContatosBusca(
          1,
          10,
          inputValue,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          watch("id_client")?.value,
        );
        const res = { ...resAgency, ...resClient };
        if (res.status === 200) {
          setUsers(res.data.data);
        }
        setLoadingUsers(false);
      } else {
        setUsers([]);
      }
    }, 300),
    [],
  );

  const handleInputChangeProtagonista = (inputValue: any) => {
    loadProtagonista(inputValue);
    return inputValue;
  };

  const loadRepresentante = useCallback(
    debounce(async (inputValue) => {
      if (inputValue) {
        setLoadingRepresentante(true);
        const res = await ServiceRepresentantes.listRepresentantes(
          1,
          10,
          inputValue,
        );
        if (res.status === 200) {
          setRepresentantes(res.data.data);
        }
        setLoadingRepresentante(false);
      } else {
        setRepresentantes([]);
      }
    }, 300),
    [],
  );

  const handleInputChangeRepresentante = (inputValue: any) => {
    loadRepresentante(inputValue);
    return inputValue;
  };

  const loadClientes = useCallback(
    debounce(async (inputValue) => {
      if (inputValue) {
        setLoadingClientesNaoMidia(true);
        const res = await GetAllClientes.listClientesPagination(
          1,
          10,
          inputValue,
        );
        if (res.status === 200) {
          setClientesNaoMidia(res.data.data);
        }
        setLoadingClientesNaoMidia(false);
      } else {
        setClientesNaoMidia([]);
      }
    }, 300),
    [],
  );

  const handleInputChangeClientes = (inputValue: any) => {
    loadClientes(inputValue);
    return inputValue;
  };

  async function handleCreateRoomFromSearch() {
    const name = roomSearch.trim();
    if (!name) return;

    setCreatingRoom(true);
    const res = await serviceMeetings.createMeetingRoom({
      name,
      color:
        DEFAULT_ROOM_COLORS[meetingRooms.length % DEFAULT_ROOM_COLORS.length],
      active: true,
    });

    if (res?.status === 201 || res?.status === 200) {
      const room = res.data?.data;
      setValue("meeting_room", buildMeetingRoomOption(room));
      setRoomSearch("");
      toast.success(res.data?.msg || "Sala criada com sucesso.");
      queryClient.invalidateQueries({ queryKey: ["meeting-rooms"] });
      queryClient.invalidateQueries({ queryKey: ["meeting-room"] });
    } else {
      toast.error(res?.data?.msg || "Erro ao criar sala de reunião.");
    }
    setCreatingRoom(false);
  }

  useEffect(() => {
    getTypesReunioes();
  }, []);

  useEffect(() => {
    if (context?.userLogged?.data?.type_user_id === 2) {
      setValue("id_agencia", {
        value: context?.userLogged?.data?.agencia?.id,
        label: context?.userLogged?.data?.agencia?.name_fantasy,
      });
    }
  }, [context?.userLogged?.data]);

  useEffect(() => {
    if (
      !shouldCheckRoomAvailability ||
      !selectedRoom ||
      !selectedStartDate ||
      !selectedEndDate
    ) {
      setCheckingRoom(false);
      setRoomAvailability(null);
      return;
    }

    if (moment(selectedEndDate).isSameOrBefore(moment(selectedStartDate))) {
      setRoomAvailability({
        available: false,
        message: "O horário final deve ser depois do horário inicial.",
        checkedKey: availabilityKey ?? undefined,
      });
      setCheckingRoom(false);
      return;
    }

    let cancelled = false;
    setCheckingRoom(true);
    setRoomAvailability(null);
    const timer = window.setTimeout(async () => {
      try {
        const res = await serviceMeetings.checkRoomAvailability({
          meeting_room_id: selectedRoom,
          date: serializeMeetingDateForApi(selectedStartDate),
          end_date: serializeMeetingDateForApi(selectedEndDate),
          exclude_id: reuniao?.id,
        });

        if (cancelled) return;

        if (res?.status === 200) {
          setRoomAvailability({
            available: !!res.data?.available,
            message: res.data?.msg,
            checkedKey: availabilityKey ?? undefined,
          });
        } else if (res?.status === 409) {
          setRoomAvailability({
            available: false,
            message:
              res.data?.msg ||
              "Esta sala já está ocupada neste horário. Selecione outra sala ou outro horário.",
            checkedKey: availabilityKey ?? undefined,
          });
        } else {
          setRoomAvailability(null);
        }
      } finally {
        if (!cancelled) setCheckingRoom(false);
      }
    }, 350);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [
    requiresRoom,
    selectedRoom,
    selectedStartDate,
    selectedEndDate,
    availabilityKey,
    shouldCheckRoomAvailability,
    reuniao?.id,
  ]);

  useEffect(() => {
    if (reuniao) {
      void editReuniao(reuniao);
    }
  }, [reuniao]);

  useEffect(() => {
    if (initialProspect && !reuniao) {
      setValue("meeting_type", { value: "reunion", label: "Reunião" });
      setValue("title", `Reunião com ${initialProspect.name}`);
      setValue("id_prospecting", {
        value: initialProspect.id,
        label: initialProspect.name,
      });
      if (initialProspect.agencia?.id) {
        setValue("id_agencia", {
          value: initialProspect.agencia.id,
          label: initialProspect.agencia.name_fantasy,
        });
      }
      if (initialProspect.cliente?.id) {
        setValue("id_client", {
          value: initialProspect.cliente.id,
          label:
            initialProspect.cliente.name_fantasy ??
            initialProspect.cliente.nome ??
            initialProspect.cliente.nome_completo,
        });
      }
      if (initialProspect.decisor?.id) {
        setValue("id_protagonista", {
          value: initialProspect.decisor.id,
          label:
            `${initialProspect.decisor.name} ${initialProspect.decisor.last_name ?? ""}`.trim(),
          image:
            initialProspect.decisor.url_img ??
            initialProspect.decisor.profilePhoto,
        });
      }
    }
  }, [initialProspect]);

  useEffect(() => {
    if (initialCandidatura && !reuniao) {
      const candidato = initialCandidatura.usuario;
      const vaga = initialCandidatura.vaga;
      const nomeCandidato =
        `${candidato?.name ?? ""} ${candidato?.last_name ?? ""}`.trim() ||
        "Candidato";
      const participante = {
        value: candidato?.id,
        label: nomeCandidato,
        image:
          candidato?.filePath ??
          resolveImageSrc(candidato?.url_img) ??
          ImageGeneric,
      };

      setValue("meeting_type", { value: "reunion", label: "Reunião" });
      setValue(
        "title",
        `Entrevista - ${nomeCandidato}${vaga?.titulo_vaga ? ` - ${vaga.titulo_vaga}` : ""}`,
      );
      setValue("id_responsavel", {
        value: user?.id,
        label: `${user?.name ?? ""} ${user?.last_name ?? ""}`.trim(),
        image: user?.filePath ?? resolveImageSrc(user?.url_img) ?? ImageGeneric,
      });
      if (candidato?.id) {
        setValue("list_integrantes", [participante]);
      }
    }
  }, [initialCandidatura, reuniao, setValue, user]);

  useEffect(() => {
    if (initialCarteiraPessoa && !reuniao) {
      const contato = initialCarteiraPessoa.pessoa;
      const agencia = initialCarteiraPessoa.agency;
      const cliente = initialCarteiraPessoa.client;
      const representante = initialCarteiraPessoa.representante;
      const representado = initialCarteiraPessoa.representado;
      const responsavel = initialCarteiraPessoa.responsavel;
      const nomeContato =
        `${contato?.name ?? ""} ${contato?.last_name ?? ""}`.trim() || "lead";

      setValue("meeting_type", { value: "reunion", label: "Reunião" });
      setValue("title", `Reunião com ${nomeContato}`);

      if (agencia?.id) {
        setValue("id_agencia", {
          value: agencia.id,
          label: agencia.name_fantasy ?? agencia.nome ?? agencia.name,
          data: agencia,
        });
      }

      if (cliente?.id) {
        setValue("id_client", {
          value: cliente.id,
          label: cliente.name_fantasy ?? cliente.nome ?? cliente.name,
        });
      }

      if (representante?.id) {
        setValue("id_representante", {
          value: representante.id,
          label:
            representante.name_fantasy ??
            representante.nome ??
            representante.name,
          data: representante,
        });
        if (representante.representados) {
          setVeiculos(representante.representados);
        }
      }

      if (representado?.id) {
        setValue("id_representado", {
          value: representado.id,
          label:
            representado.name_fantasy ?? representado.nome ?? representado.name,
          data: representado,
        });
      }

      if (contato?.id) {
        setValue("id_protagonista", {
          value: contato.id,
          label: nomeContato,
          image: contato.url_img ?? contato.profilePhoto ?? ImageGeneric,
        });
        setValue("list_integrantes", [
          {
            value: contato.id,
            label: nomeContato,
            image: contato.url_img ?? contato.profilePhoto ?? ImageGeneric,
          },
        ]);
      }

      if (responsavel?.id) {
        setValue("id_responsavel", {
          value: responsavel.id,
          label:
            `${responsavel.name ?? ""} ${responsavel.last_name ?? ""}`.trim() ||
            responsavel.email,
          image:
            responsavel.url_img ?? responsavel.profilePhoto ?? ImageGeneric,
        });
      } else if (user?.id) {
        setValue("id_responsavel", {
          value: user.id,
          label: `${user?.name ?? ""} ${user?.last_name ?? ""}`.trim(),
          image:
            user?.filePath ?? resolveImageSrc(user?.url_img) ?? ImageGeneric,
        });
      }
    }
  }, [initialCarteiraPessoa, reuniao, setValue, user]);

  async function getTypesReunioes() {
    try {
      const res = await serviceMeetings.getTypesReunions();
      if (res?.status === 200) {
        if ([3, 8].includes(typeUser)) {
          setValue("type", { value: 2, label: "Mídia" });
        }

        setTypesReunion(res?.data?.data);
      }
    } catch (error) {
      toast.error(t("meetingsModule.messages.fetch_config_error"));
    }
  }

  async function editReuniao(selected: any) {
    const requestSequence = ++editRequestSequence.current;
    let e = selected;
    try {
      if (selected.recurrence_id && !selected.recurrence) {
        const response = await serviceMeetings.getMeetingById(selected.id);
        if (requestSequence !== editRequestSequence.current) return;
        if (response?.status === 200 && response.data?.data) {
          const detail = response.data.data;
          e = {
            ...selected,
            ...detail,
            recurrence:
              detail.recurrence ?? detail.recurrenceRule ?? selected.recurrence,
          };
        }
      }
    } catch {
      // A listagem já contém os dados necessários para abrir a edição.
      // Mantemos o fallback para não bloquear o formulário por uma falha transitória.
    }
    if (requestSequence !== editRequestSequence.current) return;
    setIsEdit(true);
    setEditingRecurrenceId(e.recurrence_id ?? null);
    setShowAdditionalFields(true);
    setValue("title", e.title);
    const isEvent = e.is_reunion === false;
    setValue("meeting_type", {
      value: isEvent ? "event" : "reunion",
      label: isEvent ? "Evento" : "Reunião",
    });
    const statusOptions = [
      { value: "1", label: "Marcada" },
      { value: "2", label: "Realizada" },
      { value: "3", label: "Em Remarcação" },
    ];

    if (e.type != 2) {
      setValue("id_agencia", {
        value: e.agency?.id,
        label: e.agency?.name,
      });
      setValue("id_representante", {
        value: e.representante?.id,
        label: e.representante?.name_fantasy,
      });
      setValue("id_representado", {
        value: e.representado?.id,
        label: e.representado?.name_fantasy,
      });
    }
    if (e.type == 2) {
      e.id_prospecting &&
        setValue("id_prospecting", {
          value: e.prospecting?.id,
          label: e.prospecting?.name,
        });
    }

    setValue("id_client", {
      value: e.cliente?.id,
      label:
        e?.cliente?.name_fantasy ||
        e?.cliente?.nome ||
        e?.cliente?.nome_completo,
    });
    setValue("id_responsavel", {
      value: e?.responsavel?.id,
      label: e?.responsavel?.name,
      image: e?.responsavel?.profilePhoto,
    });
    setValue("id_protagonista", {
      value: e?.protagonista?.id,
      label: e?.protagonista?.name,
      image: e?.protagonista?.profilePhoto,
    });

    setValue("type", {
      value: e.type?.id,
      label: e.type?.name,
    });

    setValue("id_project", {
      value: e.project?.id,
      label: e.project?.name,
    });

    setValue("date", moment.utc(e.date).format("YYYY-MM-DDTHH:mm"));
    setValue(
      "end_date",
      e.end_date
        ? moment.utc(e.end_date).format("YYYY-MM-DDTHH:mm")
        : moment
            .utc(e.date)
            .add(DEFAULT_MEETING_DURATION_MINUTES, "minutes")
            .format("YYYY-MM-DDTHH:mm"),
    );
    setValue("meeting_room", buildMeetingRoomOption(e.meetingRoom ?? e));
    const fallbackWeekday = moment.utc(e.date).day();
    const fallbackTotal = Number(e.recurrence_total);
    const recurrence = e.recurrence ??
      e.recurrenceRule ?? {
        weekdays: Number.isInteger(fallbackWeekday) ? [fallbackWeekday] : [],
        end_type:
          Number.isInteger(fallbackTotal) && fallbackTotal > 1
            ? "count"
            : "never",
        end_date: null,
        occurrence_count:
          Number.isInteger(fallbackTotal) && fallbackTotal > 1
            ? fallbackTotal
            : null,
      };
    setValue("is_recurring", Boolean(e.recurrence_id));
    setValue("recurrence_weekdays", recurrence?.weekdays ?? []);
    setValue("recurrence_end_type", recurrence?.end_type ?? "never");
    setValue(
      "recurrence_end_date",
      recurrence?.end_date
        ? moment(recurrence.end_date).format("YYYY-MM-DD")
        : "",
    );
    setValue("recurrence_count", recurrence?.occurrence_count ?? 6);
    setValue("recurrence_scope", "");

    setValue(
      "list_integrantes",
      e?.integrantes?.map((integrante: any) => ({
        value: integrante?.id,
        label: `${integrante?.name} ${integrante?.last_name}`,
        image: integrante?.profilePhoto || undefined,
        email: integrante?.email,
      })),
    );
    setValue(
      "external_attendees",
      toExternalAttendeeOptions(e?.external_attendees),
    );
    const selectedStatus = statusOptions.find(
      (option) => option.value === e.status,
    );
    if (selectedStatus) {
      setValue("status", selectedStatus);
    } else {
      console.warn(`Status não encontrado para o ID: ${e.status}`);
    }
  }

  function closeModal() {
    editRequestSequence.current += 1;
    reset();
    setRoomAvailability(null);
    setShowAdditionalFields(true);
    close();
    setIsEdit(false);
    setEditingRecurrenceId(null);
    setClients([]);
    setVeiculos([]);
    setReuniao?.(null);
  }

  function formatUserData(users: any) {
    return users.map((user: any) => ({
      label: `${(user.name || "").trim()} ${(user.last_name || "").trim()}`,
      value: user.id,
      image: user.filePath,
    }));
  }

  function parseAgencyClients(rawClients?: string) {
    if (!rawClients) return [];
    try {
      return JSON.parse(rawClients);
    } catch {
      toast.error("Não foi possível carregar os clientes desta agência.");
      return [];
    }
  }

  const { isPending, data: dataRepresentados } = useQuery({
    queryKey: ["reunions-representados"],
    queryFn: async () =>
      await ServiceRepresentado.listRepresentado(1, 999999999999),
    retry: 3,
    enabled: [3].includes(typeUser),
    staleTime: 1000 * 60 * 5,
  });

  const userOptionLabel = (option: { image?: string; label: string }) => (
    <div className="flex items-center gap-2">
      <img
        className="h-6 w-6 rounded-full object-cover"
        src={option.image ?? ImageGeneric}
        alt=""
      />
      <span>{option.label}</span>
    </div>
  );

  const secondaryFieldLabel = (label: string, required = false) => (
    <label className="mb-1.5 block text-xs font-medium text-cinza-500">
      {label}{" "}
      {required ? (
        <span className="text-red-500">*</span>
      ) : (
        <span className="font-normal text-cinza-300">(opcional)</span>
      )}
    </label>
  );

  const secondaryFieldError = (name: string) =>
    errors[name]?.message ? (
      <p className="mt-1 text-xs text-red-500">
        {String(errors[name]?.message)}
      </p>
    ) : null;

  function addExternalAttendees(rawValues: string[]) {
    const current = toExternalAttendeeOptions(watch("external_attendees"));
    const nextEmails = rawValues.map(normalizeEmail).filter(Boolean);
    const invalid = nextEmails.find((email) => !isValidEmail(email));
    if (invalid) {
      toast.error(`E-mail inválido: ${invalid}`);
      return;
    }
    const internalEmails = new Set(
      (watch("list_integrantes") ?? [])
        .map((attendee: { email?: string }) =>
          attendee.email ? normalizeEmail(attendee.email) : "",
        )
        .filter(Boolean),
    );
    const internalDuplicate = nextEmails.find((email) =>
      internalEmails.has(email),
    );
    if (internalDuplicate) {
      toast.error(`${internalDuplicate} já está entre os integrantes internos.`);
      return;
    }
    setValue(
      "external_attendees",
      toExternalAttendeeOptions([
        ...current.map((attendee) => attendee.value),
        ...nextEmails,
      ]),
      { shouldDirty: true, shouldValidate: true },
    );
    setExternalAttendeeInput("");
  }

  function handleExternalAttendeesPaste(
    event: ClipboardEvent<HTMLDivElement>,
  ) {
    const pasted = event.clipboardData.getData("text");
    const values = pasted.split(/[,;\n\r\t]+/).map((value) => value.trim());
    if (values.filter(Boolean).length === 0) return;
    event.preventDefault();
    addExternalAttendees(values);
  }

  return (
    <ModalGeneric
      onClose={closeModal}
      size="w-full max-w-2xl max-h-[85vh] overflow-hidden"
      styleRounded="rounded-2xl"
    >
      <form
        className="flex max-h-[calc(85vh-3rem)] flex-col text-sm"
        onSubmit={handleSubmit(onSubmit)}
      >
        <header className="border-b border-cinza-200 pb-4">
          <div className="flex items-start justify-between gap-4">
            <div>
              <h3 className="text-xl font-semibold text-cinza-800">
                {isEdit
                  ? t("meetingsModule.form.title.edit")
                  : "Marcar novo compromisso"}
              </h3>
              <p className="mt-1 text-xs leading-5 text-cinza-500">
                Informe os dados essenciais. Os detalhes podem ser adicionados
                depois.
              </p>
            </div>
            <span className="hidden rounded-full bg-azul-400/10 px-3 py-1 text-xs font-medium text-azul-400 sm:inline-flex">
              Rápido e direto
            </span>
          </div>

          <div className="mt-4 grid grid-cols-2 rounded-xl bg-cinza-100 p-1">
            {[
              { value: "reunion", label: "Reunião", icon: UsersRound },
              { value: "event", label: "Evento", icon: CalendarDays },
            ].map((option) => {
              const Icon = option.icon;
              const selected = meetingTypeValue === option.value;
              return (
                <button
                  key={option.value}
                  type="button"
                  disabled={isEdit}
                  aria-pressed={selected}
                  onClick={() => {
                    setValue("meeting_type", {
                      value: option.value,
                      label: option.label,
                    });
                    setShowAdditionalFields(option.value === "reunion");
                    clearErrors([
                      "type",
                      "id_project",
                      "id_responsavel",
                      "id_representante",
                      "id_representado",
                    ]);
                  }}
                  className={`flex items-center justify-center gap-2 rounded-lg px-3 py-2.5 font-medium transition disabled:cursor-default ${
                    selected
                      ? "bg-white text-azul-400 shadow-sm"
                      : "text-cinza-500 hover:text-cinza-800"
                  }`}
                >
                  <Icon size={16} aria-hidden="true" />
                  {option.label}
                </button>
              );
            })}
          </div>
        </header>

        <div className="min-h-0 flex-1 space-y-5 overflow-y-auto px-1 py-5">
          <section
            aria-labelledby="essential-fields-title"
            className={isGoogleMeeting ? "opacity-75" : undefined}
          >
            {isGoogleMeeting && (
              <div className="mb-4 rounded-xl border border-blue-200 bg-blue-50 px-4 py-3 text-xs text-blue-800">
                <strong>Reunião sincronizada pelo Google Agenda.</strong> Título,
                horário, recorrência e participantes são controlados no Google.
                Aqui você pode alterar apenas as informações internas da Ad Desk.
              </div>
            )}
            <div className="mb-3 flex items-center gap-2">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-azul-400/10 text-azul-400">
                <CalendarDays size={17} aria-hidden="true" />
              </div>
              <div>
                <h4
                  id="essential-fields-title"
                  className="font-semibold text-cinza-800"
                >
                  Dados principais
                </h4>
                <p className="text-xs text-cinza-500">
                  Tudo que você precisa para reservar o horário.
                </p>
              </div>
            </div>

            <div
              className={`grid grid-cols-1 gap-4 rounded-2xl border border-cinza-200 bg-cinza-100/40 p-4 sm:grid-cols-2 ${isGoogleMeeting ? "pointer-events-none" : ""}`}
            >
              <div className="sm:col-span-2">
                <label
                  htmlFor="meeting-title"
                  className="mb-1.5 block text-xs font-medium text-cinza-800"
                >
                  Título <span className="text-red-500">*</span>
                </label>
                <input
                  id="meeting-title"
                  {...register("title", { required: !isGoogleMeeting })}
                  disabled={isGoogleMeeting}
                  type="text"
                  autoFocus={!isEdit}
                  placeholder="Ex.: Alinhamento da campanha"
                  className={`w-full rounded-lg border bg-white px-3.5 py-2.5 text-cinza-800 outline-none transition placeholder:text-cinza-300 focus:border-azul-400 focus:ring-2 focus:ring-azul-400/10 ${
                    errors.title ? "border-red-500" : "border-cinza-200"
                  }`}
                />
                {errors.title && (
                  <p className="mt-1 text-xs text-red-500">
                    Informe um título para continuar.
                  </p>
                )}
              </div>

              <div>
                <label
                  htmlFor="meeting-start"
                  className="mb-1.5 flex items-center gap-1.5 text-xs font-medium text-cinza-800"
                >
                  <Clock3 size={14} aria-hidden="true" /> Início
                  <span className="text-red-500">*</span>
                </label>
                <Controller
                  name="date"
                  control={control}
                  rules={{ required: !isGoogleMeeting }}
                  render={({ field }) => (
                    <DatePicker
                      disabled={isGoogleMeeting}
                      id="meeting-start"
                      selected={field.value ? new Date(field.value) : null}
                      onChange={(date: Date | null) => {
                        field.onChange(
                          date ? format(date, "yyyy-MM-dd'T'HH:mm") : "",
                        );
                        window.setTimeout(() => void trigger("end_date"), 0);
                        const currentEnd = watch("end_date");
                        if (
                          date &&
                          (!currentEnd ||
                            moment(currentEnd).isSameOrBefore(date))
                        ) {
                          setValue(
                            "end_date",
                            format(addHours(date, 1), "yyyy-MM-dd'T'HH:mm"),
                            { shouldValidate: true },
                          );
                        }
                      }}
                      dateFormat="dd/MM/yyyy HH:mm"
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      locale="pt-BR"
                      placeholderText="Selecione data e hora"
                      customInput={<CustomDateInput />}
                      wrapperClassName="w-full"
                      popperProps={{ strategy: "fixed" }}
                    />
                  )}
                />
                {errors.date && (
                  <p className="mt-1 text-xs text-red-500">Informe o início.</p>
                )}
              </div>

              <div>
                <label
                  htmlFor="meeting-end"
                  className="mb-1.5 flex items-center gap-1.5 text-xs font-medium text-cinza-800"
                >
                  <Clock3 size={14} aria-hidden="true" /> Fim
                  <span className="text-red-500">*</span>
                </label>
                <Controller
                  name="end_date"
                  control={control}
                  rules={{
                    required: !isGoogleMeeting,
                    validate: (value) =>
                      isGoogleMeeting ||
                      !watch("date") ||
                      moment(value).isAfter(moment(watch("date"))),
                  }}
                  render={({ field }) => (
                    <DatePicker
                      disabled={isGoogleMeeting}
                      id="meeting-end"
                      selected={field.value ? new Date(field.value) : null}
                      onChange={(date: Date | null) =>
                        field.onChange(
                          date ? format(date, "yyyy-MM-dd'T'HH:mm") : "",
                        )
                      }
                      dateFormat="dd/MM/yyyy HH:mm"
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      locale="pt-BR"
                      placeholderText="Selecione data e hora"
                      customInput={<CustomDateInput />}
                      wrapperClassName="w-full"
                      popperProps={{ strategy: "fixed" }}
                    />
                  )}
                />
                {errors.end_date && (
                  <p className="mt-1 text-xs text-red-500">
                    O fim deve ser posterior ao início.
                  </p>
                )}
              </div>

              <div className="sm:col-span-2 rounded-xl border border-cinza-200 bg-white p-3.5">
                {isRecurringEdit && (
                  <fieldset className="mb-3 border-b border-cinza-200 pb-3">
                    <legend className="mb-2 text-xs font-medium text-cinza-800">
                      Atualizar <span className="text-red-500">*</span>
                    </legend>
                    <div className="grid gap-2 sm:grid-cols-3">
                      {[
                        ["single", "Somente esta reunião"],
                        ["following", "Esta e as próximas"],
                        ["all", "Toda a série"],
                      ].map(([value, label]) => (
                        <label
                          key={value}
                          className={`flex cursor-pointer items-center gap-2 rounded-lg border px-3 py-2 text-xs transition ${
                            recurrenceScope === value
                              ? "border-azul-400 bg-azul-400/10 text-azul-400"
                              : "border-cinza-200 text-cinza-800"
                          }`}
                        >
                          <input
                            type="radio"
                            value={value}
                            {...register("recurrence_scope", {
                              required: isRecurringEdit,
                            })}
                            className="text-azul-400 focus:ring-azul-400"
                          />
                          {label}
                        </label>
                      ))}
                    </div>
                    {errors.recurrence_scope && (
                      <p className="mt-1 text-xs text-red-500">
                        Escolha quais reuniões deseja atualizar.
                      </p>
                    )}
                  </fieldset>
                )}
                <label className="flex cursor-pointer items-center justify-between gap-4">
                  <span className="flex items-center gap-3">
                    <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-azul-400/10 text-azul-400">
                      <Repeat2 size={16} aria-hidden="true" />
                    </span>
                    <span>
                      <span className="block text-xs font-medium text-cinza-800">
                        Repetir semanalmente
                      </span>
                      <span className="block text-xs text-cinza-500">
                        {isRecurringEdit
                          ? "Edite a regra semanal ou desmarque para remover a recorrência no escopo escolhido."
                          : "Cria uma ocorrência no mesmo dia e horário de cada semana."}
                      </span>
                    </span>
                  </span>
                  <input
                    type="checkbox"
                    {...register("is_recurring")}
                    onChange={(event) => {
                      setValue("is_recurring", event.target.checked, {
                        shouldValidate: true,
                      });
                      if (
                        event.target.checked &&
                        recurrenceWeekdays.length === 0 &&
                        selectedStartDate
                      ) {
                        setValue(
                          "recurrence_weekdays",
                          [moment(selectedStartDate).day()],
                          { shouldValidate: true },
                        );
                      }
                    }}
                    className="h-4 w-4 rounded border-cinza-300 text-azul-400 focus:ring-azul-400"
                  />
                </label>

                {isRecurring && (
                  <fieldset
                    disabled={isRecurringEdit && recurrenceScope === "single"}
                    className="mt-3 space-y-4 border-t border-cinza-200 pt-3 disabled:opacity-60"
                  >
                    {isRecurringEdit && recurrenceScope === "single" && (
                      <p className="text-xs text-cinza-500">
                        A regra da série será preservada ao editar somente esta
                        reunião.
                      </p>
                    )}
                    <div>
                      <span className="mb-2 block text-xs font-medium text-cinza-800">
                        Repetir em <span className="text-red-500">*</span>
                      </span>
                      <input
                        type="hidden"
                        {...register("recurrence_weekdays", {
                          validate: (value) =>
                            !isRecurring || value?.length > 0,
                        })}
                      />
                      <div
                        className="flex flex-wrap gap-2"
                        role="group"
                        aria-label="Dias da semana"
                      >
                        {WEEKDAYS.map((day) => {
                          const selected = recurrenceWeekdays.includes(
                            day.value,
                          );
                          return (
                            <button
                              key={day.value}
                              type="button"
                              aria-label={day.label}
                              aria-pressed={selected}
                              title={day.label}
                              onClick={() => {
                                const next = selected
                                  ? recurrenceWeekdays.filter(
                                      (value) => value !== day.value,
                                    )
                                  : [...recurrenceWeekdays, day.value].sort();
                                setValue("recurrence_weekdays", next, {
                                  shouldValidate: true,
                                });
                              }}
                              className={`h-9 w-9 rounded-full border text-xs font-semibold transition ${
                                selected
                                  ? "border-azul-400 bg-azul-400 text-white"
                                  : "border-cinza-200 bg-white text-cinza-500 hover:border-azul-300 hover:text-azul-400"
                              }`}
                            >
                              {day.short}
                            </button>
                          );
                        })}
                      </div>
                      {errors.recurrence_weekdays && (
                        <p className="mt-1 text-xs text-red-500">
                          Selecione ao menos um dia.
                        </p>
                      )}
                    </div>

                    <div role="group" aria-label="Término da recorrência">
                      <span className="mb-2 block text-xs font-medium text-cinza-800">
                        Termina
                      </span>
                      <div className="grid gap-3 sm:grid-cols-3">
                        {[
                          ["never", "Nunca"],
                          ["date", "Em uma data"],
                          ["count", "Após"],
                        ].map(([value, label]) => (
                          <label
                            key={value}
                            className="flex cursor-pointer items-center gap-2 text-xs text-cinza-800"
                          >
                            <input
                              type="radio"
                              value={value}
                              {...register("recurrence_end_type")}
                              className="text-azul-400 focus:ring-azul-400"
                            />
                            {label}
                          </label>
                        ))}
                      </div>
                    </div>

                    {recurrenceEndType === "date" && (
                      <div>
                        <label
                          htmlFor="recurrence-end-date"
                          className="mb-1.5 block text-xs font-medium text-cinza-800"
                        >
                          Data final <span className="text-red-500">*</span>
                        </label>
                        <input
                          id="recurrence-end-date"
                          type="date"
                          min={firstRecurrenceDate?.format("YYYY-MM-DD")}
                          {...register("recurrence_end_date", {
                            required: recurrenceEndType === "date",
                            validate: (value) =>
                              recurrenceEndType !== "date" ||
                              (!!firstRecurrenceDate &&
                                moment(value)
                                  .endOf("day")
                                  .isSameOrAfter(firstRecurrenceDate)),
                          })}
                          className={`rounded-lg border bg-white px-3.5 py-2 text-cinza-800 outline-none focus:border-azul-400 ${errors.recurrence_end_date ? "border-red-500" : "border-cinza-200"}`}
                        />
                        {errors.recurrence_end_date && (
                          <p className="mt-1 text-xs text-red-500">
                            A data final deve incluir a primeira ocorrência.
                          </p>
                        )}
                      </div>
                    )}

                    {recurrenceEndType === "count" && (
                      <div>
                        <label
                          htmlFor="recurrence-count"
                          className="mb-1.5 block text-xs font-medium text-cinza-800"
                        >
                          Quantidade de ocorrências{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          id="recurrence-count"
                          type="number"
                          min={2}
                          max={260}
                          step={1}
                          {...register("recurrence_count", {
                            valueAsNumber: true,
                            validate: (value) =>
                              recurrenceEndType !== "count" ||
                              (Number.isInteger(Number(value)) &&
                                Number(value) >= 2 &&
                                Number(value) <= 260),
                          })}
                          className={`w-28 rounded-lg border bg-white px-3.5 py-2 text-cinza-800 outline-none focus:border-azul-400 ${errors.recurrence_count ? "border-red-500" : "border-cinza-200"}`}
                        />
                        {errors.recurrence_count && (
                          <p className="mt-1 text-xs text-red-500">
                            Informe uma quantidade inteira entre 2 e 260.
                          </p>
                        )}
                      </div>
                    )}

                    {firstRecurrenceDate && recurrenceWeekdays.length > 0 && (
                      <p
                        className="rounded-lg bg-azul-400/10 px-3 py-2 text-xs text-cinza-800"
                        aria-live="polite"
                      >
                        Toda {formatWeekdayList(recurrenceWeekdays)}, às{" "}
                        {moment(selectedStartDate).format("HH:mm")}
                        {recurrenceEndType === "never" && ", sem data final"}
                        {recurrenceEndType === "date" &&
                          recurrenceEndDate &&
                          `, até ${moment(recurrenceEndDate).format("DD/MM/YYYY")}`}
                        {recurrenceEndType === "count" &&
                          recurrenceCount >= 2 &&
                          `, por ${recurrenceCount} ocorrências`}
                        . Primeira ocorrência em{" "}
                        {firstRecurrenceDate.format("DD/MM/YYYY")}.
                      </p>
                    )}
                  </fieldset>
                )}
              </div>

              <div className="sm:col-span-2">
                <div className="mb-1.5 flex items-center justify-between gap-3">
                  <label
                    htmlFor="meeting-room"
                    className="flex items-center gap-1.5 text-xs font-medium text-cinza-800"
                  >
                    <DoorOpen size={14} aria-hidden="true" /> Sala
                    <span className="text-red-500">*</span>
                  </label>
                  <button
                    type="button"
                    onClick={() => {
                      closeModal();
                      navigate("/reunioes/salas");
                    }}
                    className="text-xs font-medium text-azul-400 hover:underline"
                  >
                    Gerenciar salas
                  </button>
                </div>
                <Controller
                  name="meeting_room"
                  control={control}
                  rules={{ required: !isGoogleMeeting }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      inputId="meeting-room"
                      placeholder="Selecione uma sala"
                      isLoading={loadingRooms}
                      isDisabled={isGoogleMeeting}
                      onInputChange={(value) => {
                        setRoomSearch(value);
                        return value;
                      }}
                      onChange={(value) => {
                        field.onChange(value);
                        setRoomAvailability(null);
                      }}
                      options={roomOptions}
                      noOptionsMessage={() => "Nenhuma sala encontrada"}
                    />
                  )}
                />
                {errors.meeting_room && (
                  <p className="mt-1 text-xs text-red-500">
                    Selecione uma sala para continuar.
                  </p>
                )}

                {roomSearch.trim() && !hasRoomSearchResult && (
                  <button
                    type="button"
                    onClick={handleCreateRoomFromSearch}
                    disabled={creatingRoom}
                    className="mt-2 rounded-lg border border-azul-400/20 bg-azul-400/10 px-3 py-1.5 text-xs font-medium text-azul-400 disabled:opacity-60"
                  >
                    {creatingRoom
                      ? "Criando sala..."
                      : `Criar sala “${roomSearch.trim()}”`}
                  </button>
                )}
                {!loadingRooms &&
                  meetingRooms.length === 0 &&
                  !roomSearch.trim() && (
                    <button
                      type="button"
                      onClick={() => {
                        closeModal();
                        navigate("/reunioes/salas");
                      }}
                      className="mt-2 rounded-lg border border-azul-400/20 bg-azul-400/10 px-3 py-1.5 text-xs font-medium text-azul-400"
                    >
                      Cadastrar primeira sala
                    </button>
                  )}

                <div aria-live="polite" className="mt-2 min-h-5 text-xs">
                  {checkingRoom && (
                    <span className="flex items-center gap-1.5 text-cinza-500">
                      <span className="h-2 w-2 animate-pulse rounded-full bg-azul-300" />
                      Verificando disponibilidade...
                    </span>
                  )}
                  {!checkingRoom && roomAvailability?.available === true && (
                    <span className="flex items-center gap-1.5 text-green-700">
                      <CheckCircle2 size={14} aria-hidden="true" /> Sala
                      disponível neste horário.
                    </span>
                  )}
                  {!checkingRoom && roomAvailability?.available === false && (
                    <span className="flex items-start gap-1.5 text-red-500">
                      <CircleAlert
                        size={14}
                        className="mt-0.5 shrink-0"
                        aria-hidden="true"
                      />
                      {roomAvailability.message ||
                        "Esta sala já está ocupada. Selecione outra sala ou outro horário."}
                    </span>
                  )}
                </div>
              </div>

              <div className="sm:col-span-2">
                {secondaryFieldLabel("Integrantes")}
                <Select
                  {...register("list_integrantes")}
                  placeholder="Busque e adicione integrantes"
                  isMulti
                  value={watch("list_integrantes")}
                  onInputChange={handleInputChangeUsers}
                  isLoading={loadingUsers}
                  isDisabled={isGoogleMeeting}
                  onChange={(value) => setValue("list_integrantes", value)}
                  options={users.map((item: SelectSourceItem) => ({
                    value: item.id,
                    label: `${item.name ?? ""} ${item.last_name ?? ""}`.replace(/\s+/g, " ").trim(),
                    image: item?.filePath ?? ImageGeneric,
                    email: item.email,
                  }))}
                  noOptionsMessage={() => t("common:type_to_search")}
                  formatOptionLabel={userOptionLabel}
                />
              </div>

              <div
                className="sm:col-span-2"
                onPaste={handleExternalAttendeesPaste}
              >
                {secondaryFieldLabel("Integrantes externos")}
                <CreatableSelect<ExternalAttendeeOption, true>
                  inputId="external-attendees"
                  isMulti
                  isDisabled={isGoogleMeeting}
                  value={toExternalAttendeeOptions(watch("external_attendees"))}
                  inputValue={externalAttendeeInput}
                  onInputChange={(value) => setExternalAttendeeInput(value)}
                  onKeyDown={(event) => {
                    if (![",", ";"].includes(event.key)) return;
                    event.preventDefault();
                    if (externalAttendeeInput.trim()) {
                      addExternalAttendees(
                        externalAttendeeInput.split(/[,;]+/),
                      );
                    }
                  }}
                  options={[]}
                  placeholder="Digite ou cole e-mails separados por vírgula"
                  formatCreateLabel={(value) => `Adicionar ${normalizeEmail(value)}`}
                  isValidNewOption={(value) =>
                    isValidEmail(normalizeEmail(value))
                  }
                  noOptionsMessage={({ inputValue }) =>
                    inputValue
                      ? "Digite um e-mail válido e pressione Enter"
                      : "Digite ou cole um ou mais e-mails"
                  }
                  onCreateOption={(value) => addExternalAttendees([value])}
                  onChange={(value) =>
                    setValue("external_attendees", Array.from(value), {
                      shouldDirty: true,
                    })
                  }
                />
                <p className="mt-1 text-xs text-cinza-400">
                  {isGoogleMeeting
                    ? "Participantes são controlados no Google Agenda."
                    : "Eles receberão o convite do Google Agenda. Use Enter, vírgula ou ponto-e-vírgula, ou cole uma lista de e-mails."}
                </p>
              </div>
            </div>
          </section>

          <section className="overflow-hidden rounded-2xl border border-cinza-200">
            <button
              type="button"
              aria-expanded={showAdditionalFields}
              aria-controls="meeting-additional-fields"
              onClick={() => setShowAdditionalFields((current) => !current)}
              className="flex w-full items-center justify-between gap-4 px-4 py-3.5 text-left transition hover:bg-cinza-100/60"
            >
              <span className="flex items-center gap-3">
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-cinza-100 text-cinza-500">
                  <Settings2 size={17} aria-hidden="true" />
                </span>
                <span>
                  <span className="block font-medium text-cinza-800">
                    Informações adicionais
                  </span>
                  <span className="block text-xs text-cinza-500">
                    Agência, cliente e contexto da reunião.
                  </span>
                </span>
              </span>
              <ChevronDown
                size={18}
                aria-hidden="true"
                className={`shrink-0 text-cinza-500 transition-transform ${
                  showAdditionalFields ? "rotate-180" : ""
                }`}
              />
            </button>

            {showAdditionalFields && (
              <div
                id="meeting-additional-fields"
                className="grid grid-cols-1 gap-4 border-t border-cinza-200 bg-cinza-100/30 p-4 sm:grid-cols-2"
              >
                {isEdit && !isGoogleMeeting && (
                  <div className="sm:col-span-2">
                    {secondaryFieldLabel("Status")}
                    <Select
                      {...register("status")}
                      value={watch("status")}
                      onChange={(value) => setValue("status", value)}
                      options={[
                        {
                          value: "1",
                          label: t("meetingsModule.status.scheduled"),
                        },
                        {
                          value: "2",
                          label: t("meetingsModule.status.done"),
                        },
                        {
                          value: "3",
                          label: t("meetingsModule.status.reschedule"),
                        },
                      ]}
                    />
                  </div>
                )}

                {![3, 8].includes(typeUser) && (
                  <div>
                    {secondaryFieldLabel("Tipo de reunião", isReunion)}
                    <Select
                      {...register("type")}
                      placeholder="Selecione o tipo"
                      isDisabled={!typesReunion?.length || typeUser === 8}
                      value={watch("type")}
                      onChange={(value) => {
                        setValue("type", value);
                        if (value) clearErrors("type");
                        clearErrors(["id_representante", "id_representado"]);
                      }}
                      options={typesReunion
                        ?.filter((item: SelectSourceItem) =>
                          typeUser === 2
                            ? item?.type_id === 2
                            : item?.type_id === 1,
                        )
                        .map((item: SelectSourceItem) => ({
                          value: item?.id,
                          label: item?.name,
                        }))}
                    />
                    {secondaryFieldError("type")}
                  </div>
                )}

                {typeUser !== 2 && !isRecruitmentMeeting && (
                  <>
                    {![3, 8].includes(typeUser) && (
                      <div>
                        {secondaryFieldLabel("Projeto", isReunion)}
                        <Select
                          {...register("id_project")}
                          placeholder="Selecione o projeto"
                          isDisabled={!typesReunion.length}
                          value={watch("id_project")}
                          onChange={(value) => {
                            setValue("id_project", value);
                            if (value) clearErrors("id_project");
                          }}
                          options={
                            projetos
                              ?.filter((item: SelectSourceItem) =>
                                watch("type")?.value == 1
                                  ? ![1, 3, 4].includes(Number(item.id))
                                  : ![2, 5, 6, 7, 8, 14].includes(Number(item.id)),
                              )
                              .map((item: SelectSourceItem) => ({
                                value: item.id,
                                label: item.name,
                              })) || []
                          }
                        />
                        {secondaryFieldError("id_project")}
                      </div>
                    )}
                    <div>
                      {secondaryFieldLabel("Agência")}
                      <Select
                        {...register("id_agencia")}
                        isDisabled={typeUser === 2}
                        placeholder="Busque uma agência"
                        isClearable
                        onInputChange={handleInputChange}
                        isLoading={loadingAgency}
                        value={watch("id_agencia")}
                        onChange={(value) => {
                          setValue("id_agencia", value);
                          setValue("id_client", null);
                          const baseClientes = value?.data?.base_clientes;
                          setClients(parseAgencyClients(baseClientes));
                        }}
                        options={agencys.map((item: SelectSourceItem) => ({
                          value: item.id,
                          label: item.name_fantasy,
                          data: item,
                        }))}
                        noOptionsMessage={() => t("common:type_to_search")}
                      />
                    </div>
                    <div>
                      {secondaryFieldLabel("Cliente")}
                      {watch("type")?.value == 2 &&
                      ![3, 8].includes(typeUser) ? (
                        <Select
                          {...register("id_client")}
                          placeholder="Selecione o cliente"
                          isClearable
                          isDisabled={!clients.length}
                          value={watch("id_client")}
                          onChange={(value) => setValue("id_client", value)}
                          options={clients.map((item: SelectSourceItem) => ({
                            value: item.cliente_id,
                            label:
                              item.name ??
                              item.nameFantasia ??
                              item.nameCompleto,
                          }))}
                        />
                      ) : (
                        <Select
                          {...register("id_client")}
                          placeholder="Busque um cliente"
                          isClearable
                          onInputChange={handleInputChangeClientes}
                          isLoading={loadingClientesNaoMidia}
                          value={watch("id_client")}
                          onChange={(value) => setValue("id_client", value)}
                          options={clientesNaoMidia.map(
                            (item: SelectSourceItem) => ({
                              value: item?.id,
                              label:
                                item?.name_fantasy ??
                                item?.nome ??
                                item?.nome_completo,
                            }),
                          )}
                          noOptionsMessage={() => t("common:type_to_search")}
                        />
                      )}
                    </div>
                  </>
                )}

                {!isRecruitmentMeeting && watch("type")?.value == 2 && (
                  <>
                    {![3].includes(typeUser) && (
                      <div>
                        {secondaryFieldLabel(
                          "Representante",
                          isReunion && typeUser !== 8,
                        )}
                        <Select
                          {...register("id_representante")}
                          placeholder="Busque um representante"
                          isClearable
                          onInputChange={handleInputChangeRepresentante}
                          isLoading={loadingRepresentante}
                          value={watch("id_representante")}
                          onChange={(value) => {
                            setValue("id_representante", value);
                            if (value) clearErrors("id_representante");
                            setValue("id_representado", null);
                            if (isReunion && typeUser !== 8) {
                              setError("id_representado", {
                                type: "required",
                                message: "Selecione o veículo.",
                              });
                            }
                            setVeiculos(value?.data?.representados ?? []);
                          }}
                          options={representantes.map(
                            (item: SelectSourceItem) => ({
                              value: item.id,
                              label: item.name_fantasy,
                              data: item,
                            }),
                          )}
                          noOptionsMessage={() => t("common:type_to_search")}
                        />
                        {secondaryFieldError("id_representante")}
                      </div>
                    )}
                    {typeUser !== 8 && (
                      <div>
                        {secondaryFieldLabel("Veículo", isReunion)}
                        <Select
                          {...register("id_representado")}
                          placeholder="Selecione o veículo"
                          isClearable
                          isDisabled={
                            ![3].includes(typeUser) && !veiculos.length
                          }
                          isLoading={[3].includes(typeUser) && isPending}
                          value={watch("id_representado")}
                          onChange={(value) => {
                            setValue("id_representado", value);
                            if (value) clearErrors("id_representado");
                          }}
                          options={
                            [3].includes(typeUser)
                              ? dataRepresentados?.data?.data?.map(
                                  (item: SelectSourceItem) => ({
                                    value: item?.id,
                                    label: item?.name_fantasy,
                                  }),
                                ) || []
                              : veiculos.map((item: SelectSourceItem) => ({
                                  value: item.id,
                                  label: item.name_fantasy,
                                }))
                          }
                        />
                        {secondaryFieldError("id_representado")}
                      </div>
                    )}
                  </>
                )}

                <div>
                  {secondaryFieldLabel("Responsável", isReunion)}
                  <Select
                    {...register("id_responsavel")}
                    placeholder="Busque um responsável"
                    isClearable
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    menuPlacement="top"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 10000 }),
                    }}
                    value={watch("id_responsavel")}
                    onInputChange={handleInputChangeUsers}
                    isLoading={loadingUsers}
                    onChange={(value) => {
                      setValue("id_responsavel", value);
                      if (value) clearErrors("id_responsavel");
                    }}
                    options={formatUserData(users)}
                    noOptionsMessage={() => t("common:type_to_search")}
                    formatOptionLabel={userOptionLabel}
                  />
                  {secondaryFieldError("id_responsavel")}
                </div>

                {!isRecruitmentMeeting && (
                  <div>
                    {secondaryFieldLabel("Protagonista")}
                    <Select
                      {...register("id_protagonista")}
                      isDisabled={!watch("id_agencia") && !watch("id_client")}
                      placeholder="Busque o protagonista"
                      isClearable
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      menuPlacement="top"
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 10000 }),
                      }}
                      value={watch("id_protagonista")}
                      onInputChange={handleInputChangeProtagonista}
                      isLoading={loadingUsers}
                      onChange={(value) => setValue("id_protagonista", value)}
                      options={formatUserData(users)}
                      noOptionsMessage={() => t("common:type_to_search")}
                      formatOptionLabel={userOptionLabel}
                    />
                  </div>
                )}

                {watch("type")?.value == 1 && (
                  <div className="sm:col-span-2">
                    {secondaryFieldLabel("Prospecção")}
                    <Select
                      {...register("id_prospecting")}
                      placeholder="Busque uma prospecção"
                      isClearable
                      value={watch("id_prospecting")}
                      onInputChange={handleInputChangeProspects}
                      isLoading={loadingProspects}
                      onChange={(value) => setValue("id_prospecting", value)}
                      options={prospects.map((item: SelectSourceItem) => ({
                        value: item.id,
                        label: item.name,
                      }))}
                      noOptionsMessage={() => t("common:type_to_search")}
                    />
                  </div>
                )}
              </div>
            )}
          </section>
        </div>

        <footer className="flex flex-col-reverse gap-2 border-t border-cinza-200 bg-white pt-4 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-center text-xs text-cinza-500 sm:text-left">
            <span className="text-red-500">*</span> Campos obrigatórios
          </p>
          <div className="flex gap-2">
            <button
              type="button"
              onClick={closeModal}
              className="flex-1 rounded-lg border border-cinza-200 px-4 py-2.5 font-medium text-cinza-800 transition hover:bg-cinza-100 sm:flex-none"
            >
              {t("common:cancel")}
            </button>
            <button
              type="submit"
              disabled={
                submiting ||
                checkingRoom ||
                (shouldCheckRoomAvailability &&
                  Boolean(availabilityKey) &&
                  (roomAvailability?.available !== true ||
                    roomAvailability?.checkedKey !== availabilityKey))
              }
              className="flex-1 rounded-lg bg-azul-400 px-5 py-2.5 font-medium text-white transition hover:bg-azul-400/80 disabled:cursor-not-allowed disabled:opacity-50 sm:flex-none"
            >
              {submiting
                ? t("common:saving")
                : isEdit
                  ? "Salvar alterações"
                  : "Criar compromisso"}
            </button>
          </div>
        </footer>
      </form>
    </ModalGeneric>
  );
}
